/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import {ChangeDetectionStrategy, Component} from '@angular/core';
import {SocialBlock} from '../../classes/Elements';
import {createFont, createLineHeight, createPadding, getAssetByPath} from '../../utils';
import {AbstractBlock} from '../abstract-block';

@Component({
  selector: 'ip-social',
  templateUrl: './social.component.html',
  styleUrls: ['./social.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class SocialComponent extends AbstractBlock<SocialBlock> {
  // @Input()
  // block: SocialBlock;

  getParentStyles() {
    const { color, font, lineHeight, padding } = this.block.options;

    return {
      color,
      ...createLineHeight(lineHeight),
      ...createFont(font),
      ...createPadding(padding)
    };
  }

  getLabelStyles() {
    const { innerPadding } = this.block.options;
    return { ...createPadding(innerPadding), lineHeight: 0 };
  }

  getSocialListStyles() {
    const { align } = this.block.options;
    return {
      display: 'flex',
      placeContent:
        (align === 'left' && 'flex-start') ||
        (align === 'right' && 'flex-end') ||
        align
    };
  }

  getSocialListClasses() {
    return `social-list ${this.block.options.mode}`;
  }

  getSocialNetworkIcon(network: string) {
    return getAssetByPath(`${network}.png`);
  }
}
